//DOKUMEN
export const GET_PUSAT_OVERVIEW = "GET_PUSAT_OVERVIEW";
export const GET_PUSAT_OVERVIEW_SUCCESS = "GET_PUSAT_OVERVIEW_SUCCESS";
export const GET_PUSAT_OVERVIEW_FAIL = "GET_PUSAT_OVERVIEW_FAIL";

export const GET_PROVINSI_OVERVIEW = "GET_PROVINSI_OVERVIEW";
export const GET_PROVINSI_OVERVIEW_SUCCESS = "GET_PROVINSI_OVERVIEW_SUCCESS";
export const GET_PROVINSI_OVERVIEW_FAIL = "GET_PROVINSI_OVERVIEW_FAIL";

export const GET_KABKOT_OVERVIEW = "GET_KABKOT_OVERVIEW";
export const GET_KABKOT_OVERVIEW_SUCCESS = "GET_KABKOT_OVERVIEW_SUCCESS";
export const GET_KABKOT_OVERVIEW_FAIL = "GET_KABKOT_OVERVIEW_FAIL";

export const GET_KECAMATAN_OVERVIEW = "GET_KECAMATAN_OVERVIEW";
export const GET_KECAMATAN_OVERVIEW_SUCCESS = "GET_KECAMATAN_OVERVIEW_SUCCESS";
export const GET_KECAMATAN_OVERVIEW_FAIL = "GET_KECAMATAN_OVERVIEW_FAIL";


export const GET_DOKUMEN_PROVINSI = "GET_DOKUMEN_PROVINSI";
export const GET_DOKUMEN_PROVINSI_SUCCESS = "GET_DOKUMEN_PROVINSI_SUCCESS";
export const GET_DOKUMEN_PROVINSI_FAIL = "GET_DOKUMEN_PROVINSI_FAIL";

export const GET_DOKUMEN_KABKOT = "GET_DOKUMEN_KABKOT";
export const GET_DOKUMEN_KABKOT_SUCCESS = "GET_DOKUMEN_KABKOT_SUCCESS";
export const GET_DOKUMEN_KABKOT_FAIL = "GET_DOKUMEN_KABKOT_FAIL";

export const GET_DOKUMEN_KECAMATAN = "GET_DOKUMEN_KECAMATAN";
export const GET_DOKUMEN_KECAMATAN_SUCCESS = "GET_DOKUMEN_KECAMATAN_SUCCESS";
export const GET_DOKUMEN_KECAMATAN_FAIL = "GET_DOKUMEN_KECAMATAN_FAIL";